export const ssoConfig = {
  appId: 101,
  sso: {
    tokenExpiresInMin: 2,
    timeBeforeCallingRefreshInSecs: 1
  },
};
